import { render, staticRenderFns } from "./PagePaymentComplete.vue?vue&type=template&id=e6d4d6d2&scoped=true&"
import script from "./PagePaymentComplete.vue?vue&type=script&lang=js&"
export * from "./PagePaymentComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d4d6d2",
  null
  
)

export default component.exports